// extracted by mini-css-extract-plugin
export default {"spinner":"Payments_spinner__BVvoi","table":"Payments_table__wKFMO","thead":"Payments_thead__2gIJ5","loader":"Payments_loader__uC8n2"};